/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EvidenceArtefactSerialiser
 */
export interface EvidenceArtefactSerialiser {
  /**
   *
   * @type {number}
   * @memberof EvidenceArtefactSerialiser
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof EvidenceArtefactSerialiser
   */
  artefact?: string | null;
  /**
   *
   * @type {number}
   * @memberof EvidenceArtefactSerialiser
   */
  assessment?: number | null;
  /**
   *
   * @type {number}
   * @memberof EvidenceArtefactSerialiser
   */
  customAssessment?: number | null;
}

/**
 * Check if a given object implements the EvidenceArtefactSerialiser interface.
 */
export function instanceOfEvidenceArtefactSerialiser(value: object): value is EvidenceArtefactSerialiser {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function EvidenceArtefactSerialiserFromJSON(json: any): EvidenceArtefactSerialiser {
  return EvidenceArtefactSerialiserFromJSONTyped(json, false);
}

export function EvidenceArtefactSerialiserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EvidenceArtefactSerialiser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    artefact: json['artefact'] == null ? undefined : json['artefact'],
    assessment: json['assessment'] == null ? undefined : json['assessment'],
    customAssessment: json['custom_assessment'] == null ? undefined : json['custom_assessment'],
  };
}

export function EvidenceArtefactSerialiserToJSON(value?: Omit<EvidenceArtefactSerialiser, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    artefact: value['artefact'],
    assessment: value['assessment'],
    custom_assessment: value['customAssessment'],
  };
}
